module.exports = __webpack_public_path__ + "img/aso.ca06f916.svg";